import { useCallback } from 'react';
import type { BlackAndWhiteValue, BlackAndWhiteWeights } from '../../lib/adjustments/black-white';
import { RangeRow } from './RangeRow';
import type { AdjustmentPanelProps } from './registry';

/** Slider range matches Photoshop's B&W panel — signed percentages
 *  in [-200, 300]. Most users live in 0..100; the extended range
 *  lets the destructive Apply mode push past the natural endpoints
 *  for stylized output. */
const MIN = -200;
const MAX = 300;

export function BlackAndWhitePanel({ value, onChange }: AdjustmentPanelProps<BlackAndWhiteValue>) {
  const set = useCallback(
    (patch: Partial<BlackAndWhiteWeights>) => onChange({ weights: { ...value.weights, ...patch } }),
    [onChange, value.weights],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Reds"
        min={MIN}
        max={MAX}
        step={1}
        value={value.weights.reds}
        onChange={(v) => set({ reds: v })}
      />
      <RangeRow
        label="Yellows"
        min={MIN}
        max={MAX}
        step={1}
        value={value.weights.yellows}
        onChange={(v) => set({ yellows: v })}
      />
      <RangeRow
        label="Greens"
        min={MIN}
        max={MAX}
        step={1}
        value={value.weights.greens}
        onChange={(v) => set({ greens: v })}
      />
      <RangeRow
        label="Cyans"
        min={MIN}
        max={MAX}
        step={1}
        value={value.weights.cyans}
        onChange={(v) => set({ cyans: v })}
      />
      <RangeRow
        label="Blues"
        min={MIN}
        max={MAX}
        step={1}
        value={value.weights.blues}
        onChange={(v) => set({ blues: v })}
      />
      <RangeRow
        label="Magentas"
        min={MIN}
        max={MAX}
        step={1}
        value={value.weights.magentas}
        onChange={(v) => set({ magentas: v })}
      />
    </div>
  );
}
